import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import QRCode from 'qrcode';
import { sendIdVerificationEvent } from '../services/ageVerificationServices';
import events from '../constants/idVerificationEventStreamConstants';

function VendorLinkPage({ translate, onHide, verificationLink, useQRCode, origin }) {
  const [qrImgSrc, setQRImgSrc] = useState();
  const [showQRImg, setShowQRImg] = useState(false);
  useEffect(() => {
    async function fetchQRCode() {
      let url;
      try {
        url = await QRCode.toDataURL(verificationLink, { errorCorrectionLevel: 'H' });
        setQRImgSrc(url);
      } catch (err) {
        throw new Error(err);
      } finally {
        setShowQRImg(useQRCode && url);
      }
    }
    fetchQRCode();
  }, [useQRCode, verificationLink]);

  const linkClicked = () => {
    sendIdVerificationEvent(events.verificationLinkClicked, {
      origin
    });
  };

  return (
    <React.Fragment>
      <Modal.Header>
        <div className='email-upsell-title-container'>
          <button type='button' className='email-upsell-title-button' onClick={onHide}>
            <span className='close icon-close' />
          </button>
          <Modal.Title id='contained-modal-title-vcenter'>
            {translate('Heading.IdentityVerification')}
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className='verification-link-page-content'>
        <div className='verification-link-upsell'>{translate('Label.AgeVerifyPrompt')}</div>
        <div className='preparation-list-wrapper'>
          <div className='preparation-list-item'>
            <span className='icon-menu-document' />
            <div className='preparation-list-text'>
              <div className='preparation-title'>{translate('Label.PrepareId')}</div>
              <div className='preparation-text'>{translate('Label.ValidIdList')}</div>
            </div>
          </div>
          {showQRImg && (
            <div className='preparation-list-item'>
              <span className='icon-menu-mobile' />
              <div className='preparation-list-text'>
                <div className='preparation-title'>{translate('Label.UseSmartphone')}</div>
                <div className='preparation-text'>{translate('Label.SmartphoneRequired')}</div>
              </div>
            </div>
          )}
        </div>
        {showQRImg && (
          <div>
            <div className='verification-link-upsell'>{translate('Label.ScanQRCode')}</div>
            <div className='qr-code-wrapper'>
              <img className='qr-code-img' src={qrImgSrc} alt='qr' />
            </div>
          </div>
        )}
        <p
          className='verification-link-legal'
          dangerouslySetInnerHTML={{
            __html: translate('Label.PrivacyNoticeAndLink', {
              spanStart: "<a class='text-link' href='/info/privacy'>",
              spanEnd: '</a>'
            })
          }}
        />
        {!showQRImg && (
          <a href={verificationLink} onClick={linkClicked} target='_blank' rel='noreferrer'>
            <Button className='btn-primary-md primary-link btn-full-width'>
              {translate('Action.StartSession')}
            </Button>
          </a>
        )}
      </Modal.Body>
    </React.Fragment>
  );
}

VendorLinkPage.propTypes = {
  translate: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  verificationLink: PropTypes.string.isRequired,
  useQRCode: PropTypes.bool.isRequired,
  origin: PropTypes.string.isRequired
};

export default VendorLinkPage;
